export const languages = ['en', 'es', 'ja', 'tl', 'zh'];

export const defaultLanguage = 'en';

export const getUrlPrefix = (locale) => (locale === 'en' ? '' : `/${locale}`);
